<script src="../../router/index.js"></script>
<template>
	<div class="container product-container">
		<!--header-->
		<div class="tui-header-boxs">
			<!--			<div class="tui-header-icon">-->
			<!--				刘然然3分钟前正在浏览该商品-->
			<!--			</div>-->
		</div>
		<!--header-->
		<!--banner-->
		<div class="tui-banner-swiper">
			<van-swipe :autoplay="5000" :duration="150" @change="bannerChange" :show-indicators="false">
				<block v-for="(item, index) in banner" :key="index">
					<van-swipe-item :data-index="index">
						<img :src="item.pictureUrl" class="tui-slide-img" />
					</van-swipe-item>
				</block>
			</van-swipe>
			<div class="tui-banner-tag">
				<div>{{ bannerIndex + 1 }}/{{ banner.length }}</div>
			</div>
		</div>
		<!--banner-->
		<!--活动信息类型1、预售 2、秒杀 -->
		<div class="product-type" v-show="productInfo.isPresale==1">
			<div class="type-item">
				<p class="type-price">{{productInfo.marketPrice}}</p>
				<p class="type-title">{{productInfo.sendGoodsTime | formatDate}}发货</p>
			</div>
			<div class="type-item align-center">
				<p class="type-item-title">距预售结束</p>
				<van-count-down :time="productInfo.endTime-new Date().getTime()">
					<template #default="timeData">
						<span class="block">{{
              timeData.hours > 9 ? timeData.hours : "0" + timeData.hours
            }}</span>
						<span class="colon">:</span>
						<span class="block">{{
              timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes
            }}</span>
						<span class="colon">:</span>
						<span class="block">{{
              timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds
            }}</span>
					</template>
				</van-count-down>
			</div>
		</div>
		<div class="product-type-seckill" v-show="type==2">
			<div class="type-item">
				<p class="type-price">{{productInfo.marketPrice}}</p>
				<p class="type-title" style="text-decoration: line-through;">¥{{ productInfo.salePriceWithTax }}</p>
			</div>
			<div class="type-item align-center" v-show="productInfo.endTime<new Date().getTime() && productInfo.endTime-new Date().getTime()>0">
				<p class="seckill-title">距开始还剩</p>
				<van-count-down :time="productInfo.endTime-new Date().getTime()">
					<template #default="timeData">
						<span class="block">{{
              timeData.hours > 9 ? timeData.hours : "0" + timeData.hours
            }}</span>
						<span class="colon">:</span>
						<span class="block">{{
              timeData.minutes > 9 ? timeData.minutes : "0" + timeData.minutes
            }}</span>
						<span class="colon">:</span>
						<span class="block">{{
              timeData.seconds > 9 ? timeData.seconds : "0" + timeData.seconds
            }}</span>
					</template>
				</van-count-down>
			</div>
			<div class="type-item align-center" v-show="productInfo.endTime>new Date().getTime()">
				<p class="seckill-title">未开始</p>
			</div>
			<div class="type-item align-center" v-show="productInfo.endTime-new Date().getTime()<0">
				<p class="seckill-title">已结束</p>
			</div>
		</div>
		<div class="Collage">
			<van-popup v-model="Collage" :style="{ width: '100%' }" round  closeable close-icon="close">
				<div class="Collage-title">参与XXX的拼单</div>
				<div class="collagetext">仅剩<span>1</span>个名额，23:46:16后结束</div>
				<ul class="collageul">
					<li class="collone">
						<span>拼主</span>
						<img src="../../assets/icon/pic.png" alt="">
					</li>
					<li class="colltwo" >
						<img src="../../assets/icon/pic2.png" alt="">
					</li>
				</ul>
				<div class="btn">参与拼单</div>
			</van-popup>
		</div>
		<div class="CollageSuccess">
			<van-popup v-model="CollageSuccess" :style="{ width: '100%' }" round  closeable close-icon="close">

				<div class="Collage-title">
					<van-icon name="checked" color="#fff" size="20px"/>
					<span>拼团成功</span>
				</div>
				<ul class="collageul">
					<li class="collone">
						<span>拼主</span>
						<img src="../../assets/icon/pic.png" alt="">
					</li>
					<li class="colltwo">
						<img src="../../assets/icon/pic.png" alt="">
					</li>
				</ul>
				<div class="btn" @click="Stroll">继续逛逛</div>
				<div class="see">查看订单详情 > </div>
			</van-popup>
		</div>

		<div class="tui-pro-detail">
			<div class="tui-product-title tui-radius-all">
				<div class="tui-pro-pricebox">
					<div class="tui-pro-price">
						<div style="display: flex">
							<p>￥</p>
							<p class="tui-price">{{ productInfo.marketPrice }}</p>
<!--							<p>起</p>-->
						</div>
						<p class="tui-line-through tui-gray">
							￥{{ productInfo.salePriceWithTax }}
						</p>
					</div>
					<div class="tui-share-box" @click="shareMent=true" v-if="productInfo.share">分享</div>
				</div>
				<div class="tui-pro-titbox">
					<p class="name">{{ productInfo.name }}</p>
					<p class="tui-pro-title">{{ productInfo.subtitle }}</p>
				</div>
				<!--				<div>-->
				<!--					<div class="tui-sub-title">-->
				<!--						<p>微众分期额度可支付24期购物</p>-->
				<!--						<p class="flex">100<van-icon name="arrow" color="#fff" /></p>-->
				<!--					</div>-->
				<!--					<div class="tui-sale-info tui-size tui-gray">-->
				<!--						<div>快递：0.00</div>-->
				<!--						<div>月销2000</div>-->
				<!--						<div>浙江杭州</div>-->
				<!--					</div>-->
				<!--				</div>-->
			</div>

			<div class="tui-radius-all"  v-show="promotinList.length>0 || couponList.length>0">
				<div class="tui-list-cell" @click="coupon">
					<div class="tui-bold tui-cell-title">优惠</div>
					<div class="tui-flex-center">使用优惠预估价</div>
					<div class="tui-ml-auto">
						<van-icon name="arrow" color="#dadada" />
					</div>
				</div>

				<div class="tui-list-cell" @click="showPopup" style="padding-top: 0" v-show="promotinList.length>0">
					<div class="tui-bold tui-cell-title"></div>
					<div>
						<div class="tui-promotion-box" v-for="(item,index) in promotinList" :key="index">
							<span class="tui-tag text-sm">
								<span v-if="item.frontPromotionType==1">特价</span>
								<span v-if="item.frontPromotionType==2">折扣</span>
								<span v-if="item.frontPromotionType==3">直降</span>
								<span v-if="item.frontPromotionType==6">满额减</span>
								<span v-if="item.frontPromotionType==7">满额折</span>
								<span v-if="item.frontPromotionType==8">满金额赠</span>
<!--								<p v-if="frontPromotionType==9">满减</p>-->
<!--								<p v-if="frontPromotionType==12">满减</p>-->
<!--								<p v-if="frontPromotionType==13">满减</p>-->
<!--								<p v-if="frontPromotionType==14">满减</p>-->
							</span>
							<p>{{item.description}}</p>
						</div>
					</div>
				</div>
			</div>

			<!--			<div class="tui-radius-all">-->
			<!--				<div class="tui-list-cell" @click="popupMent=true" style="margin-left: 0;margin-right: 0">-->
			<!--					<div class="tui-bold">品质分期</div>-->
			<!--					<div class="tui-flex-center text-theme margin-left">-->
			<!--						享6期分期免息-->
			<!--					</div>-->
			<!--					<div class="tui-ml-auto">-->
			<!--						<span class="text-999">测算</span>-->
			<!--						<van-icon name="arrow" color="#dadada" />-->
			<!--					</div>-->
			<!--				</div>-->
			<!--				<div class="padding-bottom-xl padding-left-sm">-->
			<!--					<span class="tui-tag text-sm margin-right padding-lr">￥239.9*12期</span>-->
			<!--					<span class="tui-tag text-sm margin-right">￥239.9*12期</span>-->
			<!--					<span class="tui-tag text-sm margin-right">￥239.9*12期</span>-->
			<!--				</div>-->
			<!--			</div>-->

			<!-- BUG 微众商城WZSC-458
			【微众前端界面核对】商品详情页 无已选模块 -->
			<div class="tui-list-cell tui-radius-all" @click="showSKuFun">
				<div class="tui-bold tui-cell-title">已选</div>
				<div class="tui-selected-box">{{ skuProperty }}</div>
				<div class="tui-ml-auto">
					<van-icon name="arrow" color="#dadada" />
				</div>
			</div>

			<div class="tui-basic-info tui-radius-all">
				<div class="tui-list-cell" @click="popupAddress = true">
					<div class="tui-bold tui-cell-title">送至</div>
					<div class="tui-flex-center">
						<p v-if="defaultAddress.id">{{defaultAddress.addressProvinceId}}-{{defaultAddress.addressCityId}}-{{defaultAddress.addressRegionId}}</p>
						<p v-else-if="address.province">{{address.province}}-{{address.city}}-{{address.district}}</p>
						<p v-else>广东省-深圳市-南山区</p>
						<!--<span class="tui-tag margin-left">包邮</span>-->
					</div>
					<div class="tui-ml-auto">
						<van-icon name="arrow" color="#dadada" />
					</div>
				</div>
				<div class="tui-last"></div>
				<div class="flex padding-lr-sm padding-top-sm" @click="guarantee = true">
					<div class="tui-bold tui-cell-title">服务</div>
					<div class="tui-guarantee">
						<div class="tui-guarantee-item" v-for="(item, index) in productGuaranteeList" :key="index">
							<van-icon name="success" color="#1e53a4" />
							<p class="tui-pl">{{ item.guaranteeName }}</p>
						</div>
					</div>
				</div>
				<div class="flex justify-center"><van-icon name="arrow-down" color="#1e53a4"/></div>
			</div>

			<div class="tui-radius-all" @click="allComments()">
				<div class="tui-list-cell tui-between">
					<div class="tui-bold tui-cell-title">评价</div>
					<div class="tui-flex-center" @click="common">
						<p>100% </p>
						<p> 好评</p>
						<van-icon name="arrow" color="#dadada" />
					</div>
				</div>
			</div>

			<div class="group-main">
				<div class="list-cell" @click="groupClick" v-if="groupList && groupList.length > 0">
					<p>刚刚有<span class="text-theme">1人</span>人拼单成功，可立即拼单11</p>
					<p class="flex text-999">查看更多<van-icon name="arrow" color="#999" /></p>
				</div>
				<div>
					<div class="group-list" v-for="(item,index) in groupList" :key="index">
						<div class="flex align-center">
							<img :src="item.memberHead"/>
							<span class="group-list-name">{{item.memberName || '王小二'}}</span>
						</div>
						<div class="flex align-center">
							<div class="group-list-content">
								<p class="margin-bottom-xs">还差<span class="text-theme">{{item.totalMembers - item.joinedMembers}}人</span>成团</p>
								<p class="text-999 text-sm flex">
									剩余
									<van-count-down :time="item.expireTime -new Date().getTime()" @finish="hidecommendGroup(item.patchGrouponInstId)"  />
									结束
								</p>
							</div>
							<div class="group-list-but" @click="showSKuFun(item.grouponInstCode)">去拼单</div>
						</div>
					</div>
				</div>
				<van-popup v-model="groupStatus" :style="{ width: '100%' }" round  closeable close-icon="close">
					<div>
						<div class="container-title">
							<p></p>
							<p class="title">可参与的拼单</p>
							<p></p>
						</div>
						<div class="group-lists" v-for="(item,index) in groupList" :key="index">
							<div class="flex align-center">
								<img :src="item.memberHead"/>
								<span class="group-list-name">{{item.memberName || '王小二'}}</span>
							</div>
							<div class="flex align-center">
								<div class="group-list-content">
									<p class="margin-bottom-xs">还差<span class="text-theme">{{item.totalMembers - item.joinedMembers}}人</span>成团</p>
									<p class="text-999 text-sm flex">
										剩余
										<van-count-down :time="item.expireTime -new Date().getTime()" @finish="hidecommendGroup(item.patchGrouponInstId)"  />
										结束
									</p>
								</div>
								<div class="group-list-but" @click="showSKuFun(item.grouponInstCode)">去拼单</div>
							</div>
						</div>
					</div>
				</van-popup>

			</div>


		</div>

		<div>
			<div class="tui-list-cell">
				<div class="tui-bold margin-left-sm">商品介绍</div>
			</div>
			<div class="tui-product-img">
<!--				<p v-html="productInfo.describe"></p>-->
				<img v-for="(item,index) in productInfo.describe.describe" :key="index" :src="item.url"/>
				<img v-for="(item,index) in productInfo.describe.tips" :key="index" :src="item.url"/>
				<img v-for="(item,index) in productInfo.describe.price" :key="index" :src="item.url"/>
			</div>
			<div class="flex justify-between align-center bg-white padding margin-bottom">
				<div>
					<p class="text-xsm text-333">{{null!=memStoreInfo.storeName?memStoreInfo.storeName:''}}</p>
					<p class="text-sm text-999">周一到周日 9:00-18:00</p>
				</div>
				<div>
					<van-tag type="primary" size="large" plain color="#666666">
						<img src="../../../static/images/order/kefu-3@2x.png" class="kefu-img" />
						<a :href="'tel:' +memStoreInfo.mobile" style="color:rgb(102, 102, 102)">咨询商家</a>
					</van-tag>
				</div>
			</div>
			<div class="bg-white padding text-xsm">
				<div class="flex padding-bottom">
					<div class="text-999 title-width">使用快递</div>
					<p class="text-333 title-right">本商品由第三方商家承担发货和配送，具体使用 快递可致电商家咨询</p>
				</div>
				<div class="flex padding-bottom">
					<div class="text-999 title-width">配送范围</div>
					<p class="text-333 title-right">配送范围 中国大陆地区<span class="text-sm text-999">（若因不可抗性导致配送延误，请您 致电商家核实，造成不便敬请谅解）</span></p>
				</div>
				<div class="flex padding-bottom">
					<div class="text-999 title-width">关于发票</div>
					<p class="text-333 title-right">如需发票，请直接拨打供应商售后客服索取</p>
				</div>
				<div class="flex padding-bottom">
					<div class="text-999 title-width">营业执照</div>
					<p class="text-430 title-right" @click="previewImgs()">点击查看</p>
				</div>
			</div>
			<div>
				<div class="recommend-title">
					<p class="line"></p>
					<p class="title">更多推荐</p>
					<p class="line"></p>
				</div>
				<!--推荐商品-->
				<van-swipe class="my-swipe" :autoplay="3000">
					<van-swipe-item v-for="(item, index) in productArray" :key="index">
						<productItem :productList="item" @click="detail"></productItem>
					</van-swipe-item>
				</van-swipe>
				<bottom></bottom>
				<share ref="share"/>
			</div>
		</div>
		<!--商品规格底部选择层-->
		<!--商品规格底部选择层-->
		<!--服务底部弹出层-->
		<van-popup v-model="guarantee" closeable close-icon="close" position="bottom" round :style="{ height: '50%' }">
			<div class="fuwu-con">
				<div class="text-center padding text-lg text-bold">服务</div>
				<div class="padding-lr margin-bottom text-xsm" v-for="(item, index) in productGuaranteeList" :key="index">
					<div class="flex align-center margin-bottom-7">
						<van-icon name="passed" color="#d80c18" />
						<p class="margin-left-xs text-bold">{{ item.guaranteeName }}</p>
					</div>
					<div class="text-999 text-sm">{{item.guaranteeExplain}}</div>
				</div>
				<div class="fixed bg-white">
					<div class="padding-lr padding-bottom-xl">
						<van-button round color="var(--theme-color-main)" size="small" block @click="guarantee = false">确定</van-button>
					</div>
				</div>
			</div>
		</van-popup>
		<!--服务底部弹出层-->
		<!--地址底部弹出层-->
		<van-popup v-model="popupAddress" closeable close-icon="close" position="bottom" round :style="{ height: '50%' }">
			<div>
				<div class="text-center padding-top text-lg text-bold">送至</div>
				<div class="padding-lr" v-if="addressList && addressList.length > 0">
					<div class="flex align-center padding-tb text-df" style="border-bottom: 1px solid #dedede" v-for="(item, index) in addressList" :key="index" @click="chooseAddress(index)">
						<van-icon name="checked" color="#d80c18" v-show="addressIndex == index" size="21px" />
						<van-icon name="circle" color="#CDCDCD" v-show="addressIndex != index" size="21px"/>
						<p class="margin-left-sm">{{item.addressProvinceId}}-{{item.addressCityId}}-{{item.addressRegionId}}</p>
					</div>
				</div>
				<div class="fixed bg-white">
					<div class="padding-lr padding-bottom-xl">
						<van-button round color="#d80c18" size="small" block @click="goEditAddress()">新增</van-button>
					</div>
				</div>
			</div>
		</van-popup>
		<!--地址底部弹出层-->
		<!--优惠底部弹出层-->
		<van-popup v-model="popupCoupon" closeable close-icon="close" position="bottom" round :style="{ height: '50%' }">
			<div class="text-center padding-top text-lg text-bold">优惠</div>
			<div class="margin-sm">
				<!-- <div class="coupon-head">
					使用以下“<span class="coupon-tag">省</span>”标优惠，预估价<span class="text-theme">￥3199</span>
				</div> -->
				<div class="coupon-cell" v-for="(item,index) in promotinList" :key="index">
					<span class="tui-tag text-sm">
						<p>{{item.description}}</p>
					</span>
					<van-icon name="arrow" color="#dadada" size="20" v-if="item.frontPromotionType == 6 || item.frontPromotionType == 7 || item.frontPromotionType == 8" @click="goPromotionPoly(item)"/>
				</div>
				<productCoupon :list="couponList" @click="getCoupon"></productCoupon>

<!--				<div class="couponreceive">-->
<!--					<div class="coupon-title">可领取的优惠券</div>-->
<!--					<div class="tag">省</div>-->
<!--					<div class="coupon-weItem" v-for="(item, index) in dataList" :key="index">-->
<!--						<div class="weItem-back weItem-back1"></div>-->
<!--						&lt;!&ndash; <div class="weItem-back weItem-back2" v-if="item.type == 2"></div>-->
<!--			<div class="weItem-back weItem-back3" v-if="item.type == 3"></div> &ndash;&gt;-->
<!--						<div class="coupon-left">-->
<!--							<span class="coupon-left-rmb">¥</span>-->
<!--							<div class="coupon-left-right">-->
<!--								<span class="coupon-left-right-price">{{item.money}}</span>-->
<!--								&lt;!&ndash; <span class="coupon-left-rmb">折</span> &ndash;&gt;-->
<!--								<div class="coupon-left-right-alert" style="display: block;-webkit-transform-origin-x: 0;  -webkit-transform: scale(0.8);">-->
<!--									满{{item.limit}}元可用-->
<!--								</div>-->
<!--							</div>-->
<!--						</div>-->
<!--						<div class="coupon-right coupon-right-padding">-->
<!--							<div class="coupon-right-redbag">红包券</div>-->
<!--							<div class="coupon-right-title"></div>-->
<!--							<div class="coupon-time">{{item.time}} </div>-->
<!--						</div>-->
<!--					</div>-->
<!--				</div>-->
			</div>
		</van-popup>
		<!--分期底部弹出层-->
		<van-popup v-model="popupMent" closeable close-icon="close" position="bottom" round :style="{ height: '50%' }">
			<div class="text-center padding-top text-lg text-bold">送至</div>
			<div class="margin-sm">
				<ul class="ment">
					<li>
						<span class="ment-money">222.50</span>
						<span class="text-999">× 3期</span>
					</li>
				</ul>
			</div>
		</van-popup>
		<!--分享弹出层-->
		<van-popup v-model="shareMent"  position="bottom" round>
			<div class="flex justify-around share-content">
				<div class="share" @click="shareWechat">
					<img src="../../../static/images/product/weixin-2@2x.png"/>
					<span>分享给微信好友</span>
				</div>
				<div class="share" @click="posterMent=true">
					<img src="../../../static/images/product/haibao@2x.png"/>
					<span>生成海报分享</span>
				</div>
			</div>
			<div class="share-but" @click="shareMent=false">取消</div>
		</van-popup>
		<!--海报图片-->
		<van-popup v-model="posterMent" :style="{ background: 'rgb(0,0,0,0)' }">
			<div class="poster-main">
				<Sharingposters @click="clickSharing"></Sharingposters>
			</div>
		</van-popup>
		<!--拼团弹出层-->
		<van-sku v-model="show" :sku="sku" :goods="goods" :goods-id="goodsId" :hide-stock="sku.hide_stock" @buy-clicked="onBuy" @add-cart="onAddCart" @sku-selected="skuSelected" @stepper-change="stepperChange" :initial-sku="initialSku" :close-on-click-overlay="false" >
			<!-- 自定义 sku actions 操作 -->
			<template #sku-actions="props">
				<div class="flex margin-lr-sm margin-bottom">
					<van-button v-if="sku.stock_num>0" plain round block color="#979797" type="primary" @click="props.skuEventBus.$emit('sku:addCart')" class="margin-right-sm">加入购物车</van-button>
					<van-button v-if="sku.stock_num>0" round block color="var(--theme-color-main)" type="primary" @click="props.skuEventBus.$emit('sku:buy')">立即购买</van-button>
          <van-button v-if="sku.stock_num<1"   plain round block color="#c8c9cc" type="primary" @click="props.skuEventBus.$emit('sku:addCart')" class="margin-right-sm">加入购物车</van-button>
          <van-button v-if="sku.stock_num<1" round block color="#c8c9cc" class="van-sku-row__item--disabled" type="primary" @click="props.skuEventBus.$emit('sku:buy')">立即购买</van-button>
				</div>
			</template>
		</van-sku>
	</div>
</template>

<script>
	import productCoupon from "@/components/product/productCoupon.vue";
	// import productGroupItem from "@/components/product/productGroupItem.vue";
	import productItem from "@/components/product/productItem";
	import productSpec from "@/components/product/productSpec.vue";
	import Sharingposters from "@/components/product/Sharingposters.vue"; //海报
	import bottom from "@/components/bottom.vue";
	import share from "@/components/share.vue"
	import utils from "@/utils/utils";
	import wx from 'weixin-js-sdk';
	import { ImagePreview } from "vant";
	import {
		getRecommendedProductList,
		skuEvent,
		addCart,
		detailSku,
		getAddressList,
		favorite,
		queryProductCoupon,
		getPromotinInfo,
		receiveCoupon
	} from "../../api/api";
import { all } from 'q';
	// import Bottom from "../bottom";
	export default {
		filters: {
			formatDate: function (value) {
				return utils.formatPickerTime(value/1000);
			}
		},
		props: {
			banner: {
				type: Array,
				default: null,
			},
			productGuaranteeList: {
				type: Array,
				default: null,
			},
			productInfo: {
				type: Object,
				default: null,
			},
			productId: {
				type: String,
				default: null,
			},
			memStoreInfo: {
				type: Object,
				default: null,
			},
			type: {//1预售 2、秒杀 3、拼团
				type: String,
				default: 0,
			},
			// Collage:{//拼团
			// 	type: String,
			// 	default: 2,
			// },
			groupList: {
				type: Array,
				default: [],
			},
		},
		components: {
			bottom,
			share,
			productItem,
			// productGroupItem,
			productSpec,
			Sharingposters,
			productCoupon
		},
		data() {
			return {
				promotinList:[],//优惠活动
				couponList:[],//优惠劵
				grouponInstCode:'',
				time: 500000,
				groupStatus: false,
				popupMent: false,
				posterMent:false,//海报
				shareMent:false,//分享
				popupCoupon: false, //优惠弹窗
				popupAddress: false, //地址弹出
				guarantee: false, //服务弹出
				// productStatus:['商品介绍','商品参数','包装售后'],//商品详情类型
				// productStatusIndex:0,//商品详情类型默认
				addressIndex: 0, //地址默认
				productList: [],
				bannerIndex: 0,
				menuShow: false,
				popupShow: false,
				value: 1,
				Collage:false,
				CollageSuccess:false,
				collected: false,
				productArray: [],
				addressList: [], // 收货地址列表
				skuProperty: "", // 已选规格
				show: false, //是否显示sku
				goodsId: this.$route.query.id,
				sku: {
					tree: [],
					list: [],
					price: null,
					stock_num: 0, // 商品总库存
					hide_stock: false, // 是否隐藏剩余库存
				},
				goods: {
					picture: this.banner.pictureUrl,
				},
				dataList: [{
						money: "100",
						limit: "1100",
						time: "2020-11-16 07:50:00 - 2020-11-27 08:00:00"
					}
				],
				initialSku:{},
				defaultAddress: {}, //用户默认收货地址
				address:{},//用户默认无收货地址
			};
		},
		created: function() {
			if (this.$route.query.token) {
				this.$cookies.set('token', this.$route.query.token);
			}
			if (this.$route.query.address) {
				this.$cookies.set('address',this.$route.query.address);
			}
			this.address=JSON.parse(this.$cookies.get('address'));
		},
		mounted: function(options) {
			this.getProduct();
			this.initSku();
			this.getUserAddress();
			this.getProductCoupon();
			this.getPromotin();
		},
		methods: {
			// 获取优惠劵数据
			async getProductCoupon() {
				var id=this.$route.query.id
				const params = {
					"limit": 2,
					"mpId": id,
					"start": 1,
				};
				const res = await queryProductCoupon(params);
				if (res.code === "0000") {
					this.couponList=res.data.rows;
				} else {
					this.$toast(res.msg);
				}
			},
			// 跳转商品聚合页
			goPromotionPoly(item){
				this.$router.push({
					path: "/productList?promotionId=" + item.promId + "&promotionType=" + item.promotionType,
				});
			},
			// 领取优惠券
			async getCoupon(e, item, index) {
				if(item.isReceive==1){
					this.$router.push({
						path: "/productList?promotionId=" + item.promotionId,
					});
					return
				}
				var currentTarget = e.currentTarget;
				const res = await receiveCoupon({ promotionId: item.promotionId });
				if (res.code === "0000") {
					this.getProductCoupon();
					// this.list[index].status = 1;
					// currentTarget.children[0].innerText = "领取";
					// currentTarget.children[1].innerText = "成功";
					this.$toast("您已被优惠券砸中，请至卡包查看！");
				} else {
					this.$toast(res.msg);
				}
			},
			// 获取商品活动数据
			async getPromotin() {
				var id=this.$route.query.id
				const params = {
					"mpId":id,
					"productType":10
				};
				const res = await getPromotinInfo(params);
				if (res.code === "0000") {
					this.promotinList=res.data.promotions
				} else {
					this.$toast(res.msg);
				}
			},
			//海报图片保存到相册
			clickSharing(){
				this.posterMent=false
			},
			// 获取精选商品数据
			async getProduct() {
				const params = {};
				const res = await getRecommendedProductList(params);
				if (res.code === "0000") {
					if (res.data.length > 4) {
						for (let i = 0; i < res.data.length; i += 4) {
							this.productArray.push(res.data.slice(i, i + 4));
						}
					} else {
						this.productArray = res.data;
					}

					console.log(this.productArray);
				} else {
					this.$toast(res.msg);
				}
			},
			// 获取用户收货地址列表
			async getUserAddress() {
				let token = this.$cookies.get('token');
				//TODO 未登录 读取当前定位
				if (!token) {
					return;
				}
				const res = await getAddressList({
					limit: 10,
					start: 1
				});
				if (res.code === "0000" && res.data && res.data.rows) {

					this.addressList = res.data.rows;
					// 获取用户默认收货地址，如果没有默认则取第一个
					res.data.rows.forEach(item => {
						if (item.isDefault == '1') {
							this.defaultAddress = item;
						} else {
							this.defaultAddress = res.data.rows[0];
						}
					})
				} else {
					this.$toast(res.msg);
				}
			},
			// 选择收货地址
			chooseAddress(index) {
				this.addressIndex = index;
				this.defaultAddress = this.addressList[index];
			},
			// 跳转新增收货地址
			goEditAddress() {
				if (!this.checkLoginFun()) {
					return
				}
				// url="/#/orders/editAddress?formUrl"
				let url = encodeURIComponent(location.href.split("#")[1]);
				this.$router.push({
					path: "/orders/editAddress?formUrl=" + url,
				});
			},
			detail() {},
			//商品图
			bannerChange: function(e) {
				this.bannerIndex = e;
			},
			//显示拼单列表
			groupClick: function(e) {
				this.groupStatus = true;
			},
			previewimg: function(e) {},
			closeMenu: function() {
				this.menuShow = false;
			},
			showPopup: function() {
				this.popupShow = true;
			},
			Stroll:function(){
				this.CollageSuccess = false;
			},
			change: function(e) {
				this.value = e.value;
			},
			collecting: function() {
				this.collected = !this.collected;
			},
			common: function() {},
			submit() {
				this.popupShow = false;
			},
			coupon() {
				this.popupCoupon=true
			},
			//微信分享
			shareWechat() {
				this.shareMent=false
				this.$refs.share.buttonClick()
				wx.miniProgram.postMessage({ data:JSON.stringify({
						productId:this.productId,
						title:this.productInfo.name,
						pic:this.banner[0].pictureUrl
				})})
			},
			//全部评论
			allComments() {
				// this.productInfo.describe;
				// debugger
				this.$router.push({
					path: "/orders/allComments?productId=" + this.productId,
				});
			},
			submitClick() {
			},
			// 预览图片
			previewImgs() {
				ImagePreview([
					'https://img.yzcdn.cn/vant/apple-1.jpg',
					'https://img.yzcdn.cn/vant/apple-2.jpg',
				]);
			},
			//渲染sku
			async initSku() {
				var this_=this;
				const res = await detailSku({
					id: this.productId
				});
				if (res.code == "0000" && res.data) {
					res.data.forEach((ele,index) => {
						var it = {
							k: ele.name || ele.chineseName,
							k_id:index,
							k_s: 's'+parseInt(index+1),
						};

						if (ele.productPropertyValue && ele.productPropertyValue.length > 0) {
							it.v = ele.productPropertyValue.map((pp) => {
								return {
									id: pp.valueId,
									name: pp.valueName,
									imgUrl: ele.pictureUrl,
									previewImgUrl: ele.pictureUrl,
								};
							});
						} else {
							//默认
							it.v = [];
							it.v.push({
								id: "V" + ele.attNameId, //attNameId为0时，代表没有规格属性，但是vant组件图片会出不来
								name: ele.name || ele.chineseName,
								imgUrl: ele.pictureUrl,
								previewImgUrl: ele.pictureUrl,
							});

							// this.hideSkuGroup();
						}

						this.sku.tree.push(it);
						if (
							ele.productPropertyValue == null ||
							!ele.productPropertyValue ||
							ele.productPropertyValue.length == 0
						) {
							let price = ele.salePriceWithTax * 100;
							if (this.$route.query.promPrice) {
								price = this.$route.query.promPrice;
							}
							//生成默认规格属性
							let sku = {
								id: ele.id,
								price: price,
								stock_num: ele.availableStock,
							};
							sku[ele.attNameId.toString()] = "V" + ele.attNameId; //attNameId为0时，代表没有规格属性，但是vant组件图片会出不来
							// this.sku=sku;
							this.sku.stock_num=ele.availableStock;
							this.sku.tree=[];
							this.sku.list.push(sku);
							this.stepperNumber = 1;
							console.log('==',this.sku)
						}
					});
				}
			},

			//展开规格
			async showSKuFun(grouponInstCode) {
				var this_=this;
				this_.sku.list=[];
				this.grouponInstCode=grouponInstCode;
				let that = this;
				const res = await skuEvent({
					productId: this.goodsId
				});
				if (res.code == "0000") {
					this.sku.price = this.productInfo.marketPrice;
					if(this.banner[0] && this.banner[0].pictureUrl){
						this.goods.picture = this.banner[0].pictureUrl;
					}
					var priceMin=Math.min.apply(Math, res.data.map(function(o) {return o.marketPrice}));
					var initialSku2={};
					res.data.forEach((ele,index2) => {
						if (ele.productPropertyValue && ele.productPropertyValue.length > 0) {
              this.sku.stock_num=ele.availableStock;
              let sku_property_name = ele.productPropertyValue
								.map((m) => {
									return m.valueName;
								})
								.join(", ");
							let price = ele.marketPrice * 100;
							if (that.$route.query.promPrice) {
								price = that.$route.query.promPrice * 100;
							}
							let rt = {
								id: ele.id,
								price: price,
								stock_num: ele.availableStock,
								sku_property_name: sku_property_name,
							};
							if(this_.sku.tree.length>=2 && this_.sku.tree[0].v.length==this_.sku.tree[1].v.length){
								ele.productPropertyValue.forEach((element,index) => {
									rt['s'+parseInt(index+1)] = element.valueId;
									if(priceMin==ele.marketPrice){
										initialSku2['s'+parseInt(index+1)]=element.valueId;
									}
								});
							}else{
								ele.productPropertyValue.reverse().forEach((element,index) => {
									rt['s'+parseInt(index+1)] = element.valueId;
									if(priceMin==ele.marketPrice){
										initialSku2['s'+parseInt(index+1)]=element.valueId;
									}
								});
							}

							this_.sku.list.push(rt);
							console.log('多个规格sku',this.sku)
						}else{
							let price = ele.salePriceWithTax * 100;
							if (this.$route.query.promPrice) {
								price = this.$route.query.promPrice;
							}
							//生成默认规格属性
							let sku = {
								id: ele.id,
								price: price,
								stock_num: ele.availableStock,
							};
							this.sku.stock_num=ele.availableStock;
							this.sku.tree=[];
							this.sku.list.push(sku);
							this.stepperNumber = 1;
							console.log('==',this.sku)
						}
					});
					initialSku2.selectedNum=1;
					this_.initialSku=initialSku2
					this.show = true;

					console.log('=====',this.sku)
				} else {
					this.$toast(res.msg);
				}
			},

			//立即购买
			onBuy(data) {
				if (!this.checkLoginFun()) {
					return
				}
				if(this.type==3){  //拼团
					if(this.grouponInstCode){ //去参团
						wx.miniProgram.navigateTo({
							url: '/pages/submitOrder/submitOrder?goodsId=' + data.selectedSkuComb.id
									+ '&goodsNum=' + data.selectedNum
									+ '&groupProductType=1'
									+ '&orderType=group'
									+ '&groupType=2'
									+ '&promotionType=20'
									+ '&promotionId='+this.$route.query.promotionId
									+ '&saleUnitPrice='+ data.selectedSkuComb.price / 100
									+ '&groupInstCode='+ this.grouponInstCode
						})
					}else{ //开团
						wx.miniProgram.navigateTo({
							url: '/pages/submitOrder/submitOrder?goodsId=' + data.selectedSkuComb.id
									+ '&goodsNum=' + data.selectedNum
									+ '&groupProductType=1'
									+ '&orderType=group'
									+ '&groupType=1'
									+ '&promotionType=20'
									+ '&promotionId='+this.$route.query.promotionId
									+ '&saleUnitPrice='+ data.selectedSkuComb.price / 100
						})
					}

				}else{
					// wx.miniProgram.navigateTo({
					// 	url: '/pages/submitOrder/submitOrder?goodsId=' + data.selectedSkuComb.id + '&goodsNum=' + data.selectedNum +
					// 			'&groupProductType=0'
					// })
					this.$router.push({
						path: "/submitOrder?goodsId="
								+ data.selectedSkuComb.id
								+ '&goodsNum=' + data.selectedNum
								+ '&groupProductType=0'
					});
				}


				// this.$router.push({
				//   path: "/order/orderConfirm",
				//   query: {
				//     // orderType: "seckill", //是否是秒杀商品
				//     goodsId: data.selectedSkuComb.id,
				//     // promotionId: this.promotionId,
				//     promotionType:
				//       this.skillTimeId != null && this.skillTimeId != "" ? 11 : "",
				//     // goodsName: this.productInfo.name,
				//     goodsNum: data.selectedNum,
				//     // goodsUrl: this.productMedia[0].pictureUrl,
				//     // saleUnitPrice: data.selectedSkuComb.price / 100,
				//     groupProductType: "0",
				//     // skillTimeId: this.skillTimeId,
				//     // distributorId: this.$route.query.distributorId,
				//   },
				// });
			},
			skuSelected(selected) {
				if (selected.selectedSkuComb) {
					var sku = this.sku.list.filter((f) => {
						return f.id == selected.selectedSkuComb.id;
					})[0];
					this.skuProperty = sku.sku_property_name;
				}
			},
			stepperChange(number) {

				this.skuNum = number;

			},

    //加入购物车
    async onAddCart(data) {
		if (!this.checkLoginFun()) {
			return
		}
      let sendData = {
        goodsId: data.selectedSkuComb.id,
        goodsName: this.productInfo.name,
        goodsUrl: this.banner.pictureUrl,
        saleUnitPrice: data.selectedSkuComb.price / 100,
        goodsNum: data.selectedNum,
        selected: true,
      };
      const res = await addCart(sendData);
      if (res.code == "0000") {
        this.$toast("添加成功！");
        this.show = false;
        this.popupShow = false;
        this.$parent.userCartNum();
      } else {
        this.$toast(res.msg);
      }
    },

    // 店铺/商品-收藏/取消收藏
    async follow(type) {
      if (!this.checkLoginFun()) {
        return
      }
      let sendData = {
        storeInfo: {},
        collectIds: []
      }
      //entityType 1是商品 2是店铺
      //type 1:收藏 0:取消收藏
      // isFavorite 店铺
      // isFavoriteProduct 商品
      sendData.type = type=="0"?'1':'0'
      sendData.collectIds.push(this.productInfo.id)
      sendData.entityName = this.productInfo.name
      sendData.entityType = 1
      const res = await favorite(sendData)
      if (res.code == '0000') {
        // if (num == 2) {
        //   this.isFavorite = !this.isFavorite
        // } else {
        //   this.isFavoriteProduct = !this.isFavoriteProduct
        // }
        if (sendData.type == 1) {
          this.$toast('收藏成功')
          this.$emit('func',"1")
        } else {
          this.$toast('取消成功')
          this.$emit('func',"0")
        }
        this.initFun(this.$route.query.id);
      } else {
        this.$toast('取消成功')
      }
    },
	// 检测用户是否登录
	checkLoginFun() {
		if (!utils.checkLogin()) {
			wx.miniProgram.navigateTo({
				url: '/pages/login/login'
			})
			return false
		} else {
			return true
		}
	},
			hidecommendGroup(){

			}
  },
};
</script>

<style lang="scss" scoped>
.Collage{
	text-align: center;
	.Collage-title{
		padding-top: 59px;
		font-size: 30px;
		font-family: PingFangSC, PingFangSC-Medium;
		color: #333333;
		line-height: 30px;
	}
	.collagetext{
		padding-top: 12px;
		font-size: 26px;
		font-family: PingFangSC, PingFangSC-Regular;
		font-weight: 400;
		color: #666666;
		line-height: 26px;
		span{
			color: #D80C18;
		}
	}
	.collageul{
		padding-top: 38px;
		padding-bottom: 70px;
		display: flex;
		justify-content: center;
		align-items: flex-end;
		.collone{
			display: flex;
			flex-direction: column;
			align-items: center;
			span{
				width: 84px;
				height: 40px;
				font-size: 26px;
				font-family: PingFangSC, PingFangSC-Medium;
				color: #ffffff;
				background: #d80c18;
				border-radius: 19px;
				margin-bottom: -20px;
				position: relative;
				z-index: 99;
			}
			img{
				width: 100px;
				height: 100px;
				border-radius: 100px;
				border: 4px #d80c18 solid;
			}
		}
		.colltwo{
			padding-left: 30px;
			img{
				width: 100px;
				height: 100px;
				border-radius: 100px;
			}
		}
	}
	.btn{
		margin: 0 auto;
		font-size: 32px;
		color: #ffffff;
		width: 420px;
		height: 74px;
		line-height: 74px;
		background: #d80c18;
		border-radius: 37px;
		margin-bottom: 60px;
	}

}
.CollageSuccess{
	text-align: center;
	.Collage-title{
		display: flex;
		justify-content: center;
		align-items: center;
		width: 750px;
		height: 108px;
		background: linear-gradient(270deg,#f69b4a, #d80c18);
		span{
			padding-left: 16px;
			font-size: 32px;
			color: #ffffff;
		}
	}
	.collagetext{
		padding-top: 12px;
		font-size: 26px;
		font-family: PingFangSC, PingFangSC-Regular;
		font-weight: 400;
		color: #666666;
		line-height: 26px;
		span{
			color: #D80C18;
		}
	}
	.collageul{
		padding-top: 68px;
		padding-bottom: 70px;
		display: flex;
		justify-content: center;
		align-items: flex-end;
		.collone{
			display: flex;
			flex-direction: column;
			align-items: center;
			span{
				width: 84px;
				height: 40px;
				font-size: 26px;
				font-family: PingFangSC, PingFangSC-Medium;
				color: #ffffff;
				background: #d80c18;
				border-radius: 19px;
				margin-bottom: -20px;
				position: relative;
				z-index: 99;
			}
			img{
				width: 100px;
				height: 100px;
				border-radius: 100px;
				border: 4px #d80c18 solid;
			}
		}
		.colltwo{
			padding-left: 40px;
			img{
				width: 100px;
				height: 100px;
				border-radius: 100px;
			}
		}
	}
	.btn{
		margin: 0 auto;
		font-size: 32px;
		color: #ffffff;
		width: 420px;
		height: 74px;
		line-height: 74px;
		background: #d80c18;
		border-radius: 37px;
		margin-bottom: 30px;
	}
	.see{
		font-size: 26px;
		text-align: center;
		color: #999999;
		padding-bottom: 24px;
	}
}
.product-container {
  padding-bottom: 110px;
  background-color: #f1f1f1;
}

.tui-tag {
  border: 1px solid $theme-color-main;
  border-radius: 6px;
  padding: 5px 7px;
  color: $theme-color-main;
}

.tui-header-boxs {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 995;
  .tui-header-icon {
    position: fixed;
    top: 50px;
    left: 10px;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    transform: translateZ(0);
    z-index: 9999;
    background: rgba(0, 0, 0, 0.27);
    border-radius: 7px;
    font-size: 26px;
    color: #ffffff;
    padding: 0 15px;
  }
}

.tui-banner-swiper {
  position: relative;
  width: 750px;
  height: 750px;
}

.tui-banner-tag {
  position: absolute;
  color: #fff;
  bottom: 20px;
  right: 20px;
  width: 80px;
  height: 80px;
  background: rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  text-align: center;
  line-height: 80px;
  font-size: 26px;
}

.tui-slide-img {
  width: 100%;
  height: 750px;
  display: block;
}

/*活动信息类型 秒杀 预售*/
.product-type {
  background-image: url("../../../static/images/product/advance.png");
  height: 100px;
  background-size: 100% 100%;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  padding-left: 134px;
  padding-right: 38px;
  .colon {
    display: inline-block;
    margin: 0 4px;
    color: #2616ff;
  }
  .block {
    display: inline-block;
    color: #fff;
    font-size: 26px;
    text-align: center;
    width: 40px;
    height: 40px;
    background: #2616ff;
    border-radius: 8px;
  }
  .type-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0;
  }
  .type-item-title{
    color: #2616ff;
  }
  .type-price {
    font-size: 38px;
    font-weight: 700;
  }
  .type-price::before {
    content: "¥";
    font-size: 30px;
    font-weight: 400;
  }
  .type-title {
    font-size: 24px;
  }
}
.product-type-seckill{
  background-image: url("../../../static/images/product/seckill@2x.png");
  height: 100px;
  background-size: 100% 100%;
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  padding-left: 134px;
  padding-right: 38px;
  .colon {
    display: inline-block;
    margin: 0 4px;
    color: #2616ff;
  }
  .block {
    display: inline-block;
    color: #fff;
    font-size: 26px;
    text-align: center;
    width: 40px;
    height: 40px;
    background: #F73175;
    border-radius: 8px;
  }
  .type-item {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px 0;
  }
  .seckill-title{
    color: #f73175;
  }
  .type-price {
    font-size: 38px;
    font-weight: 700;
  }
  .type-price::before {
    content: "¥";
    font-size: 30px;
    font-weight: 400;
  }
  .type-title {
    font-size: 24px;
  }
}


/*内容 部分*/
.tui-padding {
  padding: 0 30px;
  box-sizing: border-box;
}

.tui-ml-auto {
  margin-left: auto;
}

.tui-size {
  font-size: 24px;
  line-height: 24px;
}

.tui-gray {
  color: #999;
}

.tui-radius-all {
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
  background-color: #ffffff;
}

.tui-mtop {
  margin-top: 26px;
}

.tui-pro-detail {
  box-sizing: border-box;
  color: #333;
  margin: 20px;
}

.tui-product-title {
  background: #fff;
  padding: 30px 20px;
}

.tui-pro-pricebox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #ff201f;
  font-size: 36px;
  font-weight: bold;
  line-height: 44px;
}

.tui-pro-price {
  display: flex;
  align-items: center;
}

.tui-price {
  font-size: 58px;
}

.tui-original-price {
  font-size: 26px;
  line-height: 26px;
  padding: 10px 30px;
  box-sizing: border-box;
}

.tui-line-through {
  text-decoration: line-through;
  font-size: 24px;
}

.tui-collection {
  color: #333;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  height: 44px;
}

.tui-scale-collection {
  transform: scale(0.7);
  transform-origin: center 90%;
  line-height: 24px;
  font-weight: normal;
  margin-top: 4px;
}

.tui-pro-titbox {
  font-size: 42px;
  font-weight: 500;
  position: relative;
  box-sizing: border-box;
  margin-top: 30px;
  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }
}

.tui-pro-title {
  font-size: 28px;
}

.tui-share-btn {
  display: block;
  background: transparent;
  margin: 0;
  padding: 0;
  border-radius: 0;
  border: 0;
}

.tui-share-btn::after {
  border: 0;
}

.tui-share-box {
  width: 95px;
  height: 40px;
  background: #d80c18;
  border-radius: 20px 0 0px 20px;
  font-size: 26px;
  color: #ffffff;
  text-align: center;
  line-height: 40px;
  margin-right: -20px;
}

.tui-share-position {
  position: absolute;
  right: 0;
  top: 30px;
}

.tui-share-text {
  padding-left: 8px;
}

.tui-sub-title {
  padding: 0px 20px;
  background: $theme-color-main;
  height: 88px;
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #ffffff;
  font-size: 28px;
}

.tui-sale-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 30px;
}

.tui-list-cell {
  display: flex;
  align-items: center;
  font-size: 26px;
  line-height: 26px;
  padding: 30px 20px;
  box-sizing: border-box;
  background-color: #ffffff;
}

.tui-right {
  position: absolute;
  right: 30px;
  top: 30px;
}

.tui-bold {
  font-weight: bold;
}

.tui-last {
  border-bottom: 1px solid #efefef;
  width: 95%;
  margin: 0 auto;
}

.tui-flex-center {
  display: flex;
  align-items: center;
}

.tui-cell-title {
  width: 66px;
  padding-right: 30px;
  flex-shrink: 0;
  font-size: 26px;
  color: #333333;
}

.tui-promotion-box {
  display: flex;
  align-items: center;
  padding: 10px 0;
  width: 550px;
}

.tui-promotion-box p {
  margin-left: 24px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tui-guarantee {
  display: flex;
  flex-wrap: wrap;
  font-size: 24px;
}

.tui-guarantee-item {
  display: flex;
  color: #666666;
  padding-right: 30px;
  padding-bottom: 25px;
}

.tui-pl {
  padding-left: 4px;
}

.tui-between {
  justify-content: space-between !important;
}

.tui-cmt-all {
  color: $theme-color-main;
  padding-right: 8px;
}

.tui-cmt-content {
  font-size: 26px;
}

.tui-cmt-user {
  display: flex;
  align-items: center;
}

.tui-acatar {
  width: 60px;
  height: 60px;
  border-radius: 30px;
  display: block;
  margin-right: 16px;
}

.tui-cmt {
  padding: 14px 0;
}

.tui-attr {
  font-size: 24px;
  color: #999;
  padding: 6px 0;
}

.tui-cmt-btn {
  padding: 50px 0 30px 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tui-nomore-box {
  padding-top: 10px;
}

.tui-product-img {
  margin-bottom: 20px;
}
/*底部选择弹层*/
.tui-popup-box {
  position: relative;
  padding: 30px 0 100px 0;
}

.tui-popup-btn {
  width: 100%;
  position: absolute;
  left: 0;
  bottom: 0;
}

.tui-product-box {
  display: flex;
  font-size: 24px;
  padding-bottom: 30px;
}

.tui-popup-img {
  height: 200px;
  width: 200px;
  border-radius: 24px;
  display: block;
}

.tui-popup-price {
  padding-left: 20px;
  padding-bottom: 8px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .tui-name {
    height: 80px;
    font-size: 28px;
    color: #333333;
  }
  .tui-amount {
    color: #ff201f;
    font-size: 58px;
  }
  .tui-amount:before {
    content: "¥";
    font-size: 28px;
    margin-right: 10px;
  }
}
.tui-popup-scroll {
  height: 600px;
  font-size: 26px;
  overflow: scroll;
}
.fuwu-con {
	overflow-y: scroll;
}
.tui-scrollview-box {
  padding: 0 30px 60px 30px;
  box-sizing: border-box;
}

.tui-attr-title {
  padding: 10px 0;
  color: #333;
  font-size: 28px;
}

.tui-attr-box {
  font-size: 0;
  padding: 20px 0;
}

.tui-attr-item {
  max-width: 100%;
  min-width: 120px;
  height: 60px;
  display: -webkit-inline-flex;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f1f1f1;
  padding: 0 20px;
  box-sizing: border-box;
  margin-right: 20px;
  margin-bottom: 20px;
  font-size: 26px;
  border-radius: 30px;
}

.tui-attr-active {
  background: $theme-color-main !important;
  color: #fff;
  font-weight: bold;
  position: relative;
}
.tui-number-box {
  display: flex;
  flex-direction: column;
  padding: 0px 0 30px 0;
  align-items: flex-start;
}
/*底部选择弹层*/

/*商品类型切换*/
.tui-product-status {
  display: flex;
  flex: 1;
  height: 96px;
  border-radius: 10px;
  overflow: hidden;
  align-items: center;
  background-color: #ffffff;
  font-size: 28px;
  color: #999999;
  div {
    width: 33.3%;
    height: 100%;
    text-align: center;
    line-height: 96px;
  }
  .tui-product-status-active {
    background-color: $theme-color-main;
    color: #ffffff;
    overflow: hidden;
  }
}

/*推荐*/
.recommend-title {
  display: flex;
  align-items: center;
  justify-content: center;
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    margin: 50px 20px;
  }
  .line {
    width: 40px;
    height: 5px;
    background: linear-gradient(270deg, #fda42f 0%, #f25541);
    border-radius: 3px;
  }
}
.my-swipe {
  padding-bottom: 40px;
	/deep/.van-swipe__indicator {
		background: #d8d8d8 !important;
	}
	/deep/.van-swipe__indicator--active {
		width: 30px !important;
		height: 10px !important;
		background: #ffffff !important;
		border-radius: 5px !important;
	}
	/deep/.van-sku-stepper-stock{
		display: flex;
		flex-direction: column;
	}
}
/*分期*/
.ment {
  display: flex;
  flex-wrap: wrap;
  li {
    height: 180px;
    line-height: 180px;
    border: 1px solid #dedede;
    text-align: center;
    width: 49.5%;
    font-size: 28px;
    .ment-money:before {
      content: "¥";
      font-size: 26px;
      color: $theme-color-main;
    }
  }
}
 /*优惠 */
.coupon-head{
  font-size: 30px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: bold;
  color: #333333;
  line-height: 30px;
  border-bottom: 1px solid #dedede;
  padding: 30px 0;
}
.coupon-tag{
  background: $theme-color-main;
  color: #ffffff;
  padding: 1px 8px;
  border-radius: 8px;
}
.coupon-cell{
  display: flex;
  justify-content: space-between;
  font-family: PingFangSC, PingFangSC-Regular;
  padding: 30px 0;
  color: #333333;
  border-bottom: 1px solid #dedede;
  p{
    font-size: 26px;
  }
}
.title-width{
  width: 120px;
  padding-right: 20px;
}
.title-right{
  width: 530px;
}
.kefu-img{
  width: 30px;
  height: 30px;
  margin-right: 5px;
}
/*分享	*/
.share{
	display: flex;
	flex-direction: column;
	align-items: center;
	img{
		width: 70px;
		height: 70px;
	}
	span{
		font-size: 26px;
		color: #333333;
		margin-top: 25px;
	}
}
.share-content{
	padding-top: 70px;
	padding-bottom: 84px;
}
.share-but{
	width: 100%;
	height: 78px;
	background: #f5f5f5;
	text-align: center;
	line-height: 78px;
}
/*分享海报*/
.poster-main{
	width: 500px;
}
/deep/.van-button--small{
	height: 78px;
}

.group-main{
	.list-cell {
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 26px;
		line-height: 26px;
		padding: 30px 20px;
		background-color: #ffffff;
		margin-bottom: 20px;
		border-radius: 10px;
	}
	.group-list{
		height: 142px;
		background: #ffffff;
		border-radius: 71px;
		display: flex;
		justify-content: space-between;
		overflow: hidden;
		padding-left: 36px;
		margin-bottom: 20px;
		img{
			width: 76px;
			height: 76px;
			border-radius: 50%;
		}
		.group-list-name{
			font-size: 28px;
			color: #333333;
			margin-left: 20px;
		}
		.group-list-but{
			width: 168px;
			height: 142px;
			background-color: $theme-color-main;
			font-size: 32px;
			font-weight: bold;
			text-align: center;
			color: #ffffff;
			line-height: 142px;
		}
		.group-list-content{
			text-align: right;
			font-size: 30px;
			padding-right: 27px;
		}
	}

	.container-title{
		display: flex;
		justify-content: space-between;
		padding: 30px 20px 40px 20px;
		border-bottom: 1px solid #eaeaea;
		font-size: 30px;
		.title{
			font-weight: bold;

		}
	}
	.group-lists{
		background: #ffffff;
		display: flex;
		justify-content: space-between;
		overflow: hidden;
		margin: 0 30px;
		padding: 0px 10px;
		height: 130px;
		border-bottom: 1px solid #eaeaea;
		img{
			width: 76px;
			height: 76px;
			border-radius: 50%;
		}
		.group-list-name{
			font-size: 28px;
			color: #333333;
			margin-left: 20px;
		}
		.group-list-but{
			background-color: $theme-color-main;
			font-size: 32px;
			width: 148px;
			height: 54px;
			line-height:54px;;
			border-radius: 27px;
			text-align: center;
			color: #ffffff;
		}
		.group-list-content{
			text-align: right;
			font-size: 30px;
			padding-right: 30px;
		}
	}
}
.tui-icon{
	margin-top: -5px;
	padding-bottom: 20px;
}
</style>
<style lang="scss">
.tui-product-img {
  img {
    width: 100%;
  }
}
</style>
